// Импорт изображений
// Веб-сайты
export const Toystream = require("../img/Toystream.webp");
export const Sequoia = require("../img/Sequoia.webp");
export const Marico = require("../img/Marico.webp");
// Логотипы
export const scastle = require("../img/strong-castle-company.webp");
export const lion = require("../img/lion-games.webp");
export const bravo = require("../img/bravo-studio.webp");
export const cat_artio = require("../img/cat-artio.webp");
export const dborn = require("../img/dragon-born-studio.webp");
export const adv_borjor = require("../img/adv-briks.webp");
export const mariana = require("../img/mariana-studio.webp");
export const dwalley = require("../img/dragon-walley-team.webp");
export const bsibir = require("../img/bunny-sibirian.webp");
export const wpalace = require("../img/white-palace.webp");
// Фирменный стиль
export const center_agency = require("../img/center_agency.webp");
export const emi = require("../img/emi.webp");
export const boni_kutusu = require("../img/boni-kutusu.webp");
export const hotuas = require("../img/hotuas.webp");
// Изображения
export const akva_dragon = require("../img/akva-dragon.webp");
export const andro_fly = require("../img/andro-fly.webp");
export const bay = require("../img/bay-adventure.webp");
export const cman = require("../img/cookie-man.webp");
export const elephants = require("../img/elephants.webp");
export const ushi_dragon = require("../img/ushi-dragon.webp");
export const velo_fun = require("../img/velo-fun.webp");
export const wild = require("../img/wild.webp");
// Презентации
export const break_company = require("../img/break.webp");
export const ofan = require("../img/neuro-ofan-study.webp");
export const officeo = require("../img/officeo.webp");
export const peddle = require("../img/peddle.webp");
export const wake = require("../img/wake.webp");